module.exports = __webpack_public_path__ + "img/www.theknot.com.061ff9c8.png";